<template>
  <b-form-group
    :id="'input-group-' + id"
    :label="label"
    style="font-size: 12px"
  >
    <b-form-checkbox-group
      v-model="option"
      :id="'checkboxes-' + id"
      :class="'custom-box checkbox-grid-' + isColumn"
      :invalid-feedback="'*Campo Obrigatório'"
    >
      <b-form-checkbox
        :value="option.value"
        v-for="(option, index) in options"
        :key="index"
      >
        {{ option.text }}
      </b-form-checkbox>
      <b-form-invalid-feedback :state="state" style="font-size: 10.5px">
        {{ invalidFeedback }}
      </b-form-invalid-feedback>
    </b-form-checkbox-group>
  </b-form-group>
</template>

<script>
export default {
  name: 'check-box',
  props: {
    options: {
      type: Array,
      required: true,
    },
    model: {
      required: true,
      default: null,
    },
    label: {
      required: true,
      default: null,
    },
    invalidFeedback: {
      required: true,
      default: null,
    },
    id: {
      type: String,
      required: true,
      default: null,
    },
    isColumn: {
      type: String,
      default: 'disabled',
    },
    state: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    option: {
      get() {
        return this.model;
      },
      set(val) {
        this.$emit('update:model', val);
      },
    },
  },
  methods: {},
  mounted() {},
};
</script>
<style lang="css">
.checkbox-grid-activated {
  display: flex;
  flex-wrap: wrap;
}

.checkbox-grid-activated .custom-control {
  flex: 0 0 25%;
  box-sizing: border-box;
}

.custom-control-label {
  padding-top: 4px;
  text-align: center;
}

@media (max-width: 1020px) {
  .custom-box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
</style>
